import { VStack } from '@televet/kibble-ui';
import React, { ReactNode } from 'react';

type FormAnswersContainerProps = {
  children: ReactNode;
  borderLeftColor?: string;
  small?: boolean;
};

export const FormAnswersContainer = ({ children, borderLeftColor, small }: FormAnswersContainerProps): JSX.Element => {
  return (
    <VStack
      className="WidgetRequest__Form-Answers"
      data-testid="widget-request-form-answers"
      align="stretch"
      justify="flex-start"
      mt={small ? 0 : 6}
      pt={small ? 2 : undefined}
      px={4}
      borderLeftWidth="2px"
      borderLeftColor={borderLeftColor || 'border.brand'}
    >
      {children}
    </VStack>
  );
};
